import config from '@/config';
import fetch from '@/fetch';

const BASE_URL = config.url.api.transfeera + '/financial/billingHistory';

const getBilletPdf = invoiceId => {
  return fetch(
    `${BASE_URL}/${encodeURIComponent(invoiceId)}/boletos/pdf`,
    {},
    {
      isBlob: true,
      isFile: true
    }
  );
};

export default {
  get: () => fetch(BASE_URL),
  hasPayRequest: () => fetch(BASE_URL + '/hasPayRequest'),
  hasOverdue: () => fetch(BASE_URL + '/hasOverdue'),
  payRequest: () => fetch(BASE_URL + '/payRequest'),
  getMonthlyReport: date => fetch(`${BASE_URL}/report/monthly?date=${date}`),
  getBilletPdf
};
